import React, { useState, useEffect } from "react";
import { fetchDashboardStats } from "../../services/dashboardService";
import useCounterAnimation from "../../hooks/useCounterAnimation";
import { Link } from "react-router-dom";
import DashboardCharts from "./DashboardCharts";

export const DashboardBasicDetails = () => {
  const [dashboardStats, setDashboardStats] = useState({
    totalSales: 0,
    totalOrders: 0,
    totalCustomers: 0,
    todaysOrder: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchDashboardStats();
        const data = response.result;

        setDashboardStats({
          totalSales: data.totalSales,
          totalOrders: data.totalOrders,
          totalCustomers: data.totalCustomers,
          todaysOrder: data.todaysOrder,
        });
      } catch (error) {
        console.error("Error fetching dashboard stats:", error);
      }
    };

    fetchData();
  }, []);

  const totalOrdersCount = useCounterAnimation(dashboardStats.totalOrders, 5);
  const totalCustomersCount = useCounterAnimation(
    dashboardStats.totalCustomers,
    5
  );
  const todaysOrderCount = useCounterAnimation(dashboardStats.todaysOrder, 1);

  return (
    <>
      <div className="row">
        <div className="col-xl-3 col-md-6">
          <div className="card card-animate">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                    Total Sales
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between mt-4">
                <div>
                  <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                    ₹{Math.floor(dashboardStats.totalSales).toLocaleString()}
                  </h4>
                  <a href="/order" className="text-decoration-underline">
                    View sales
                  </a>
                </div>
                <div className="avatar-sm flex-shrink-0">
                  <span className="avatar-title bg-success rounded fs-3">
                    <i className="mdi mdi-cash-multiple"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6">
          <div className="card card-animate">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                    Total Orders
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between mt-4">
                <div>
                  <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                    {totalOrdersCount}
                  </h4>
                  <a href="/order" className="text-decoration-underline">
                    View Orders
                  </a>
                </div>
                <div className="avatar-sm flex-shrink-0">
                  <span className="avatar-title bg-info rounded fs-3">
                    <i className="mdi mdi-archive-cog"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6">
          <div className="card card-animate">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                    Today's Orders
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between mt-4">
                <div>
                  <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                    {todaysOrderCount}
                  </h4>
                  <a href="/order" className="text-decoration-underline">
                    View orders
                  </a>
                </div>
                <div className="avatar-sm flex-shrink-0">
                  <span className="avatar-title bg-warning rounded fs-3">
                    <i className="mdi mdi-archive-cog"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-md-6">
          <div className="card card-animate">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                    Registered Customers
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between mt-4">
                <div>
                  <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                    {totalCustomersCount}
                  </h4>
                  <Link
                    to={{
                      pathname: `/customer`,
                    }}
                    className="text-decoration-underline"
                  >
                    View customers
                  </Link>
                </div>
                <div className="avatar-sm flex-shrink-0">
                  <span className="avatar-title bg-danger rounded fs-3">
                    <i className="mdi mdi-account-multiple"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DashboardCharts />
    </>
  );
};

export default DashboardBasicDetails;
